import {config} from "../../constants/config";

export default {
  listRegions: [],
  listPlans: [],
  listOS: [],
  listIso: [],
  listStartupScript: [],
  listSnapShot: [],
  listApplication: [],
  listFireWallGroup: [],
}



// WEBPACK FOOTER //
// ./src/store/moduleInstance/state.js